import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import type {
  ImportCapitalNeedFileMutation,
  ImportFileInput,
  ImportFileOutputData,
} from '#/graphql/types';
import { importCapitalNeedFile } from '#/graphql/mutations';

const q = gql(importCapitalNeedFile);

const useImportCapitalNeedFileMutation = () => {
  const [mutation, result] = useMutation<ImportCapitalNeedFileMutation>(q);
  const importCapitalNeedFile = useCallback(
    async (data: ImportFileInput): Promise<ImportFileOutputData | null> => {
      const response = await mutation({
        variables: {
          data,
        },
      });

      const result = get(response, 'data.importCapitalNeedFile', undefined);

      // Check if the operation failed on the backend
      if (result && result.status !== 200) {
        const errorMessage = result.errors?.join('\n') || 'Import failed';
        throw new Error(errorMessage);
      }

      return get(response, 'data.importCapitalNeedFile.data', null);
    },
    [mutation],
  );

  return { importCapitalNeedFile, result };
};

export default useImportCapitalNeedFileMutation;
